import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mail14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.375 2.25C0.839166 2.25 0.25 2.65442 0.25 3.33333V10.6667C0.25 11.3456 0.839166 11.75 1.375 11.75H12.625C13.1608 11.75 13.75 11.3456 13.75 10.6667V3.33333C13.75 2.65442 13.1608 2.25 12.625 2.25H1.375ZM1.75 5.4014V10.25H12.25V5.40141L7.00001 8.9014L1.75 5.4014ZM12.0229 3.75H1.97707L7.00001 7.09863L12.0229 3.75Z'
      fill='currentColor'
    />
  </Svg>
);

Mail14.displayName = 'Mail14';
export default Mail14;
